export default {
    pregnancy: 'Pregnancy',
    indication                                  :   'indication',
    examinationMethod                           :   'examinationMethod',
    examinationView                             :   'examinationView',
    medicalAbbreviationTest                     :   'medicalAbbreviationTest',
    medicalAbbreviationTestDate                 :   'medicalAbbreviationTestDate',
    gestationalMedicalAbbreviationTest          :   'gestationalMedicalAbbreviationTest',
    gestationalMedicalAbbreviationTestWeek      :   'gestationalMedicalAbbreviationTestWeek',
    gestationalMedicalAbbreviationTestDay       :   'gestationalMedicalAbbreviationTestDay',
    gestationalSacType							:   'gestationalSacType',
    gestationalLocationType						:   'gestationalLocationType',
    yolkSacType									:   'yolkSacType',
    embryoSonographicType						:   'embryoSonographicType',
    uterusPosition                            	:   'uterusPosition',
    cRL											:	'cRL',
    cRLEquatWeek								:	'cRLEquatWeek',
    cRLEquatDay									:	'cRLEquatDay',
    cardiacActivity                             :   'cardiacActivity',
    bothOvariesType								:   'bothOvariesType',
    pouchDouglasType							:	'pouchDouglasType',
    impressionLocation                          :   'impressionLocation',
    planAndFollowUpType							:	'planAndFollowUpType',
    finalDescription                            :  'finalDescription',
}